import React, { useContext } from 'react'
import TestTakers from './TestTakers'
import CreateAssessments from 'pages/Admin/CreateAssessments/Assessments'
import { CreatePracticesContext, STEPS } from './CreatePracticesContext'
import { createPracticeHooks } from '.'
import { Chip, IconButton } from 'components/Form'

const CreatePractices = () => {
    const { selectedTestTaker, currentStep, setCurrentStep, customFilters, selectedAssessmentDefs, setSelectedAssessmentDefs } = useContext(CreatePracticesContext)

    const { learning_unit, test_taker_name } = selectedTestTaker || {}

    const createPractices = createPracticeHooks.useCreatePractices()

    return (
        <React.Fragment>
            {currentStep == STEPS.SELECT_STUDENT && <TestTakers />}
            {currentStep == STEPS.SELECT_ASSESSMENTS &&
                <React.Fragment>
                    <div className="selected-test-taker-summary">
                        {"התלמיד שנבחר"}
                        <Chip color="gray">
                            {test_taker_name}
                        </Chip>
                        {"במסגרת לימודים"}
                        <Chip color="gray">
                            {learning_unit?.display_name}
                        </Chip>
                        <IconButton
                            width={40}
                            height={40}
                            icon={<i class="fa-light fa-pen"></i>}
                            size="small"
                            action={() => setCurrentStep(STEPS.SELECT_STUDENT)}
                        />
                    </div>
                    <CreateAssessments
                        customFilters={customFilters}
                        isPractice={true}
                        showBattery={false}
                        selectedAssessmentDefs={selectedAssessmentDefs}
                        setSelectedAssessmentDefs={setSelectedAssessmentDefs}
                        createAssessments={createPractices}
                    />
                </React.Fragment>}
        </React.Fragment>
    )
}

export default CreatePractices